import { Injectable } from "@angular/core";
import { ActivatedRoute, CanDeactivate, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { SetDirtyForm } from "../_store/navigation/navigation.actions";
import { AppConstants } from "../constants/constants";

export interface FormComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: "root",
})
export class FormComponentDeactivateGuard
  implements CanDeactivate<FormComponentDeactivate>
{
  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ){}
  public dirty: boolean = false;
  public activity: Subject<void> = new Subject<void>();
  public cancelled: Subject<boolean> = new Subject<boolean>();
  public message: string =  AppConstants.DIRTY_FORM;
  public child: boolean = false;
  public parentPath: string = AppConstants.BLANK;
  canDeactivate(
    component: FormComponentDeactivate,
    currentRoute: import("@angular/router").ActivatedRouteSnapshot,
    currentState: import("@angular/router").RouterStateSnapshot,
    nextState?: import("@angular/router").RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if(this.blockChild(nextState) && this.dirty) {
      return false;
    }
    
    if(component) {
      this.store.dispatch(SetDirtyForm({value: this.dirty}));

      if (this.dirty){
        this.activity.next();
        let response = confirm(this.message);   
        
        if(response && this.child) {
          this.dirty = !response;
        }

        this.cancelled.next(!response);
        return response;
      };
      return true;
    }
    return true;
  }

  private blockChild(nextState: RouterStateSnapshot): boolean {
    if(this.child) {
      if(nextState && nextState?.url.includes(this.parentPath)) {
        return true;
      }
    }
    return false;
  }
}
